<template>
  <el-dialog :visible.sync="visible" title="教师评价详情" :close-on-click-modal="false" :close-on-press-escape="false" customClass="customWidth" :append-to-body="true">
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-club__classhour">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="query()">
        <el-form-item prop="rollDate">
          <el-date-picker
                  @change="getSelectDate"
                  v-model="dataForm.selectDate"
                  type="date"
                  placeholder="点名日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click.native="query()" type="primary">{{ $t('query') }}</el-button>
        </el-form-item>
      </el-form>

      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column prop="realName" label="教师姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="评分时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="studentName" label="评分学生" header-align="center" align="center"></el-table-column>
        <el-table-column prop="evaluateItemName" label="评价项" header-align="center" align="center"></el-table-column>
        <el-table-column prop="evaluateItemType" label="评价类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.evaluateItemType === 0" size="small" type="danger"
                    effect="dark">
              扣分项
            </el-tag>
            <el-tag v-else-if="scope.row.evaluateItemType === 1" size="small" type="success"
                    effect="dark">
              加分项
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="评价分数" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('studentEvaluate:studentEvaluateScore:delete')" type="text" size="small" @click="deleteByidHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
              :current-page="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limit"
              :total="total"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="pageSizeChangeHandle"
              @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import { itemType } from '@/constant'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      itemType,
      mixinViewModuleOptions: {
        getDataListURL: '/studentEvaluate/studentEvaluateScore/teacherEvaluateStatisticsDetails',
        getDataListIsPage: true,
        createdIsNeed: false,
        deleteURL: '/studentEvaluate/studentEvaluateScore',
        deleteIsBatch: true,
        activatedIsNeed: false
      },
      ids: [],
      dataForm: {
        creator: '',
        selectDate: ''
      },
      visible: false
    }
  },
  watch: {},
  components: {
  },
  mounted () {
  },
  methods: {
    init () {
      this.visible = true
      this.getDataList()
      this.getSelectDate()
      this.$nextTick(() => {
      })
    },
    deleteByidHandle (id) {
      this.$confirm(this.$t('prompt.info', { handle: this.$t('delete') }), '是否删除评分', {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.ids.push(id)
        this.$http.get('/studentEvaluate/studentEvaluateScore/deleteById/' + id).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.query()
          this.$emit('refreshDataList')
          this.$notify({
            type: 'info',
            duration: '850',
            message: '评分撤销成功'
          })
        })
      })
    },
    getSelectDate () {
      if (this.dataForm.selectDate === '') {
        this.dataForm.selectDate = new Date()
      }
      console.log(this.dataForm.selectDate)
      const date = new Date(this.dataForm.selectDate)
      const selectDate = date.getFullYear() + '-' + (this.appendZero(date.getMonth() + 1)) + '-' + this.appendZero(date.getDate())
      this.dataForm.selectDate = selectDate
    },
    appendZero (obj) {
      if (obj < 10) {
        return '0' + obj
      } else {
        return obj
      }
    }
  }
}
</script>
<style>
  .customWidth{
    width:80%;
  }
</style>
